/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { createRoot } from "react-dom/client";
import { App } from "./App";

function start() {
  const root = createRoot(document.getElementById("root")!);
  root.render(<App />);

  // PWA: inject manifest & apple-touch-icon (can't be in HTML — Bun's bundler would try to resolve them)
  const manifest = document.createElement("link");
  manifest.rel = "manifest";
  manifest.href = "/manifest.json";
  document.head.appendChild(manifest);

  const touchIcon = document.createElement("link");
  touchIcon.rel = "apple-touch-icon";
  touchIcon.href = "/icons/icon-192x192.png";
  document.head.appendChild(touchIcon);

  // Register service worker
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register("/sw.js").catch(() => { });
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
